import { Component, OnInit, Input } from '@angular/core';
import { LabMDM, SelectableLab } from '../masterdata/models/lab';
import { BusinessArea } from '../masterdata/models/businessArea';
import { MessagesService } from '../messages/messages.service';
import { MasterDataService } from '../masterdata/masterdata.service';
import { ErrorHandler } from '../utils/error-handler';
import { MasterList } from '../masterdata/masterList-enum';
import { SelectItem } from 'primeng/api/selectitem';
import { HazardousType } from '../masterdata/hazardousType-enum';
import { SelectableHazardousType } from '../masterdata/selectable-hazardoustype';
import { MachineType } from '../masterdata/models/machineType';
import { BmsProductName } from '../masterdata/models/BmsProductName';
import { Printer } from '../masterdata/models/printer';
import { SelectableProcessStep } from '../masterdata/models/SelectableProcessStep';
import { SelectableWellType } from '../masterdata/models/SelectableWellType';
import { SelectableCategory } from '../masterdata/models/SelectableCategory'
import { isEmpty } from 'rxjs/operators';
import { Chemical } from '../masterdata/models/chemical';
import { SelectableAssayType } from '../masterdata/models/SelectableAssayType';
import { Product } from '../masterdata/models/product';
import { AssayType } from '../masterdata/models/assayType-enum';
import { ChemicalCategory } from '../masterdata/models/chemicalCategory-enum'
import { EchoConfig } from '../masterdata/models/echoConfig';
import { SalesItemTypeConfig } from '../masterdata/models/salesitemtype-config';
import { Template } from '../masterdata/models/template';
import { MdmProcessStepService } from '../mdm-process-step/mdm-process-step.service';
import { MachineFileTypeOptions, MachineManufacturerOptionsCycler, MachineManufacturerOptionsExtractor, MachineManufacturerOptionOther,IOCapacityOptions } from './machine-options';
import { MaterialType, WellType } from '../common-services/carrier-enum';
import { TagSystem } from '../masterdata/models/tag-system';
import { WorkFlow } from '../masterdata/models/workflow';
import { SnpProfile } from '../masterdata/models/snp-profile';
import { OperetionHistoryDTO } from '../masterdata/models/operationHistory';


@Component({
  selector: 'app-crud-table',
  templateUrl: './crud-table.component.html',
  styleUrls: ['./crud-table.component.css']
})
//This component is used for displaying the table with the content coming from the parent component.
//It also includes crud operations for the data in the table
export class CrudTableComponent implements OnInit {

  @Input() masterLists: any[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() labOptions: LabMDM[];
  @Input() baOptions: BusinessArea[];
  @Input() masterListType: MasterList;
  @Input() countries: SelectItem[];
  @Input() hazardousTypeOptions: SelectableHazardousType[];
  @Input() machineTypesOptions: MachineType[];
  @Input() bmsProductNames: BmsProductName[];
  @Input() printerOptions: Printer[];
  @Input() processStepOptions: SelectableProcessStep[];
  @Input() bufferChemicalOptions: Chemical[];
  @Input() assayTypeOptions: SelectableAssayType[];
  @Input() productOptions: Product[];
  @Input() echoConfigOptions: EchoConfig[];
  @Input() sitConfigOptions: SalesItemTypeConfig[];
  @Input() maxRedoValues: SelectItem[];
  @Input() reactionOptionValues: SelectItem[];

  @Input() checkSelectedLab: SelectableLab;
  labOption: LabMDM[] = [];
  isNotIpAddress = true;
  warningText: string;

  displayMasterListDialog: boolean;
  isNewMasterList: boolean;
  displayDeleteDialog: boolean = false;
  masterList: any;
  selectedMasterList: any;
  isActive: string = "active";
  isLab: string = "lab";
  isHazardousType: string = "hazardousType";
  isBA: string = "businessArea";
  isProductType: string = "product";
  baTitle: string = "Business Areas";
  isDefaultLanguage: string = "defaultLanguage";
  isCountry: string = "countryName";
  isOriginalVolume: string = "originalVolume";
  isRemainingVolume: string = "remainingVolume";
  isMachineType: string = "type";
  isWellType: string = "containerType";
  isWorkflow: string = "workflow";
  isCategory: string = "category";
  isSalesItemType: string = "salesItemType";
  isBmsKitProductName: string = "bmsKitProductName";
  isBmsTubeProductName: string = "bmsTubeProductName";
  isProcessStepPrinter: string = "printer";
  isProcessStepMachineType: string = "machineType";
  isProcessStepName: string = "name";
  isDefault: string = "default";
  isBuffer: string = "buffer";
  isAssayType: string = "assayType";
  isJobTime: string = "jobTime";
  isPremixed: string = "premixed";
  isPlateSealing: string = "plateSealing";
  isHostAddress = 'hostAddress';
  isDefaultTemplate = 'template';
  isMaxRedo = "maxRedo"
  isLiquidHandling: string = "liquidHandling";
  isMeasurements: string = "measurements";
  isScanner: string = "scanner";
  isSequencer: string = "sequencer";
  isReactionOptionProtocol = "reactionOptionProtocol";
  isFileType: string = 'fileType';
  isIOCapacity: string = 'ioCapacity';
  isManufacturer: string = 'manufacturer';
  isNumberOfPC: string = "numberOfPC";
  isNumberOfNC: string = "numberOfNC";

  isReducedConfirmationTests: string = "reducedConfirmationTests";
  haveClippingMachine: string = "clippingMachine";
  isUnboxingInBatches: string = "unboxingInBatches"
  isReportingOutsideBB: string = "reportingOutsideBB";
  batchIDRegex: string = "batchIDRegex";
  isFlaTestProcess: string = "flaTestProcess";
  isNumberOfPositivePCRControls = "numberOfPositivePCRControls";
  isNumberOfNegativePCRControls = "numberOfNegativePCRControls";
  selectedLab: LabMDM;
  selectedBA: BusinessArea;
  selectedMachineType: MachineType;
  selectedHazardoustype: SelectableHazardousType;
  errorHandler: ErrorHandler = new ErrorHandler;
  selectedCountryCode: string;
  selectedLabName: string;
  selectedBaName: string;
  selectedMachineTypeName: string;
  selectedProdType: Product;
  selectedProdTypeName: string;
  popupTitle: string;
  seqConfigType = MasterList.SEQUENCER_CONFIG;
  ChemicalType = MasterList.CHEMICAL;
  chemicalLabs: SelectableLab[];
  selectedChemicalLab: SelectableLab;
  machineType = MasterList.MACHINE;
  processStep = MasterList.CARRIER_STATUS;
  product = MasterList.PRODUCT;
  wellTypes: SelectableWellType[];
  selectedWellType: SelectableWellType;
  selectedBufferChemical: Chemical;
  selectedAssayType: SelectableAssayType;
  categories: SelectableCategory[];
  selectedCategory: SelectableCategory;

  selectedEchoConfig: EchoConfig;
  echoConfigType: MasterList.ECHO_CONFIGURATION;

  selectedSalesItemTypeNames: string[] = [];
  selectedSitConfigArray: SalesItemTypeConfig[] = [];

  selectedBmsKitProductName: BmsProductName;
  selectedBmsTubeProductName: BmsProductName;
  selectedBufferName: string;

  selectedPrinterName: string;
  selectedPrinter: Printer;

  selectedProcessStep: SelectableProcessStep;

  printer = MasterList.PRINTER;
  selectedTemplate: Template;
  selectedTemplateName: string;
  labelTemplateOptions: Template[];
  selectedMaxRedo: number;
  reactionOption: string;

  machineManufacturerOptions: SelectItem[] = [];
  machineFileTypeOptions: SelectItem[] = MachineFileTypeOptions;
  ioCapacityOptions: SelectItem[] = IOCapacityOptions;
  selectedMachineFileType: string;
  selectedMachineManufacturer: string;
  ioCapacity: string;

  dateOptions:SelectItem[]=[]
  dateTimeFormatOptions:SelectItem[]=[]
  workfileDateTimeFormatOptions:SelectItem[]=[]

  selectedDateFormat:string;
  selectedDateTimeFormat:string;
  selectedWorkfileFormat:string;
  

  tagSystem: string = "tagSystem";
  isrequiredRead: string ="requiredRead";
  tagSystemOptions: any[];
  workFlowOptions: any[];
  selectedWorkflowType: WorkFlow;
  selectableLab = JSON.parse(localStorage.getItem('lab'));
  selectedTagSystem:TagSystem;
  selectedSnpProfile: SnpProfile;
  snpProfileOptions: any[];
  isSnpProfile: string ="snpProfile";
  puid = localStorage.getItem('PUID');

  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService, private _msdmProcessStepService: MdmProcessStepService) {
    this.wellTypes = [
      { label: WellType.WELL96, wellType: WellType.WELL96 },
      { label: WellType.WELL384, wellType: WellType.WELL384 }
    ];

    this.categories = [
      { label: ChemicalCategory.BUFFER, category: ChemicalCategory.BUFFER },
      { label: ChemicalCategory.OTHERS, category: ChemicalCategory.OTHERS }
    ];
  }

  ngOnInit() {
    this.popupTitle = this.title.slice(0, -1);
    this.machineManufacturerOptions = this.getAllManufacturerOptions();
    this.dateOptions =[
      {label:'DD.MM.YYYY' ,value:'dd.MM.yyyy'},
      {label:'DD.MM.YY' ,value:'dd.MM.yy'},
      {label:'MM/DD/YYYY' ,value :'MM/dd/yyyy'},
      {label:'MM/DD/YY',value:'MM/dd/yy'},
      {label:'YYYY-MM-DD',value:'yyyy-MM-dd'},
      {label:'YY-MM-DD',value:'yy-MM-dd'}
    ]
    this.dateTimeFormatOptions =[
      {label:'DD.MM.YYYY hh:mm:ss' ,value:'dd.MM.yyyy HH:mm:ss'},
      {label:'DD.MM.YYYY hh:mm' ,value:'dd.MM.yyyy HH:mm'},
      {label:'DD.MM.YY hh:mm:ss' ,value:'dd.MM.yy HH:mm:ss'},
      {label:'DD.MM.YY hh:mm' ,value:'dd.MM.yy HH:mm'},
      {label:'MM/DD/YYYY hh:mm:ss' ,value:'MM/dd/yyyy HH:mm:ss'},
      {label:'MM/DD/YYYY hh:mm' ,value:'MM/dd/yyyy HH:mm'},
      {label:'MM/DD/YY hh:mm:ss' ,value:'MM/dd/yy HH:mm:ss'},
      {label:'MM/DD/YY hh:mm' ,value:'MM/dd/yy HH:mm'},
      {label:'YYYY-MM-DD hh:mm:ss' ,value:'yyyy-MM-dd HH:mm:ss'},
      {label:'YYYY-MM-DD hh:mm' ,value:'yyyy-MM-dd HH:mm'},
      {label:'YY-MM-DD hh:mm:ss' ,value:'yy-MM-dd HH:mm:ss'},
      {label:'YY-MM-DD hh:mm' ,value:'yy-MM-dd HH:mm'},
    ]
    this.workfileDateTimeFormatOptions=[
      {label:'YYYYMMDD_hhmmss' ,value:'yyyyMMdd_HHmmss'},
      {label:'YYYYMMDD_hhmm' ,value:'yyyyMMdd_HHmm'},
      {label:'YYMMDD_hhmmss' ,value:'yyMMdd_HHmmss'},
      {label:'YYMMDD_hhmm' ,value:'yyMMdd_HHmm'},
      {label:'YYYY-MM-DD_hh-mm-ss' ,value:'yyyy-MM-dd_HH-mm-ss'},
      {label:'YYYY-MM-DD_hh-mm' ,value:'yyyy-MM-dd_HH-mm'},
      {label:'YY-MM-DD_hh-mm-ss' ,value:'yy-MM-dd_HH-mm-ss'},
      {label:'YY-MM-DD_hh-mm' ,value:'yy-MM-dd_HH-mm'},
    ]
  }   

  getAllManufacturerOptions() {
    return MachineManufacturerOptionsCycler.concat(MachineManufacturerOptionsExtractor).concat(MachineManufacturerOptionOther);
    
  }

  // This function is triggered on selecting the row in the table.
  // It opens a popup for modifying the data.
  onRowSelect(event) {
    this.isNewMasterList = false;
    this.masterList = this.cloneMasterList(event.data);
    this.displayMasterListDialog = true;
    this.getActiveOptionsForDropdowns();
    this.selectedCountryCode = this.masterList.countryCode;
    this.selectedDateFormat= this.masterList.dateFormat;
    this.selectedDateTimeFormat = this.masterList.dateTimeFormat;
    this.selectedWorkfileFormat =  this.masterList.workfileNameFormat;
    this.getHazardousType(this.masterList.hazardousType);
    this.getSelectedBmsProductName(this.masterList.bmsKitProductName, this.masterList.bmsTubeProductName);
    this.getWellType(this.masterList.containerType);
    this.getAssayType(this.masterList.assayType);
    this.getCategory(this.masterList.category);
    this.selectedSitConfigArray = [];
    this.isJobTime = 'jobTime';
    this.selectedMaxRedo = this.masterList.maxRedo;
    this.reactionOption = this.masterList.reactionOptionProtocol;
    this.selectedMachineFileType = this.masterList.fileType;
    this.ioCapacity=this.masterList.ioCapacity;
    this.selectedMachineManufacturer = this.masterList.manufacturer;
  }

  // in product,sales item type options in the dropdown is based on the Lab selected
  //this is triggered when lab in selected from the drop down
  onLabSelect(lab) {

    if (this.masterListType == MasterList.PRODUCT) {
      this.selectedSitConfigArray = [];
      var labId = lab._id;
      this._masterDataService.getSalesItemTypeFilteredByLab(labId).subscribe(
        results => {
          if (!results) {
            return;
          }
          console.log("sits: ", results.data);
          this.sitConfigOptions = results.data;

          this.sitConfigOptions.forEach(config => {
            this.masterList.salesItemType.forEach(selectedConfig => {
              if (this.masterList && this.masterList.salesItemType && config._id == selectedConfig._id) {
                if (!this.containsObject(config, this.selectedSitConfigArray)) {
                  this.selectedSitConfigArray.push(config);
                }
              }
            })
          })
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
          this.displayMasterListDialog = true;
        }
      );
    }
    else if (lab._id != null && this.masterListType == MasterList.PRINTER) {
      this.labelTemplateOptions = [];
      this.selectedTemplate = null;
      this._masterDataService.getActiveTemplatesForLab(lab, true,'').subscribe(
        results => {
          if (!results) {
            return;
          }
          this.labelTemplateOptions = results.data;
          this.labelTemplateOptions.forEach(template => {
            if (this.masterList && this.masterList.template && template.id == this.masterList.template._id) {
              this.selectedTemplateName = template.templateName;
              this.selectedTemplate = template;
            }
          })
          if (!this.masterList || !this.masterList.template || this.selectedTemplateName != this.masterList.template.templateName)
            this.selectedTemplate = null;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          message.summary = 'Template Not Found';
          message.detail = "Barcode Template Not Found for Printer's Lab";
          this._messageService.addErrorMessage(message);
        });
    }

    else if (lab._id != null && this.masterListType == MasterList.MACHINE) {
      this.machineTypesOptions = [];
      this._msdmProcessStepService.getMachineTypesByLab(lab, true).subscribe(
        results => {
          if (!results) {
            return;
          }
          this.machineTypesOptions = results.data;
          this.machineTypesOptions.forEach(type => {
            if (this.masterList && this.masterList.type && type._id == this.masterList.type._id) {
              this.selectedMachineTypeName = this.masterList.type.name;
              this.selectedMachineType = type;
            }
          })
          if (!this.masterList || !this.masterList.type || this.selectedMachineTypeName != this.masterList.type.name)
            this.selectedMachineType = null;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );
    }
  }

  // checks if obj(object) is present in the list(array of objects)
  containsObject(obj, list) {
    var i;
    for (i = 0; i < list.length; i++) {
      var a = list[i];
      if (obj._id == (a._id)) {
        return true;
      }
    }
    return false;
  }
  //This function is triggered on click of add button.It displays the popup to add the data into the table.
  showDialogToAddMasterList() {
    this.isNewMasterList = true;
    this.masterList = {}
    this.displayMasterListDialog = true;
    this.getActiveOptionsForDropdowns();
    this.selectedBA = null;
    this.selectedLab = null;
    this.selectedCountryCode = null;
    this.selectedDateFormat= null;
    this.selectedDateTimeFormat = null;
    this.selectedWorkfileFormat =null;
    this.selectedProdType = null;
    this.selectedHazardoustype = null;
    this.selectedChemicalLab = null;
    this.selectedMachineType = null;
    this.selectedSitConfigArray = [];
    this.sitConfigOptions = [];
    this.selectedBmsKitProductName = null;
    this.selectedBmsTubeProductName = null;
    this.selectedProcessStep = null;
    this.selectedWellType = null;
    this.selectedAssayType = null;
    this.selectedBufferChemical = null;
    this.selectedCategory = null;
    this.selectedEchoConfig = null;
    this.isJobTime = null;
    this.isNotIpAddress = true;
    this.selectedTemplate = null;
    this.selectedMachineFileType = null;
    this.ioCapacity = null;
    this.selectedMachineManufacturer = null;
    this.selectedSnpProfile=null;
    this.selectedWorkflowType=null;
    this.selectedTagSystem=null;

  }

  getAssayType(assayType: AssayType) {
    if (assayType != null && assayType != undefined) {
      switch (assayType.toString()) {
        case "HS_LARGE_FRAGMENT": {
          this.selectedAssayType = { label: 'HS Large Fragment', assayType: AssayType.HS_LARGE_FRAGMENT }
          break;
        }
        case "HS_NGS_FRAGMENT": {
          this.selectedAssayType = { label: 'HS NGS Fragment', assayType: AssayType.HS_NGS_FRAGMENT }
          break;
        }
        case "SS_NGS_FRAGMENT": {
          this.selectedAssayType = { label: 'SS NGS Fragment', assayType: AssayType.SS_NGS_FRAGMENT }
          break;
        }

      }
    }
  }

  getHazardousType(hazardousType: string) {
    switch (hazardousType) {
      case "Explosives": {
        this.selectedHazardoustype = { label: "Explosives", hazardousType: HazardousType.EXPLOSIVES }
        break;
      }
      case "Acute Toxicity": {
        this.selectedHazardoustype = { label: "Acute Toxicity", hazardousType: HazardousType.ACUTE_TOXICITY }
        break;
      }
      case "Aspiration Hazard": {
        this.selectedHazardoustype = { label: "Aspiration Hazard", hazardousType: HazardousType.ASPIRATION_HAZARD }
        break;
      }
      case "Compressed Gases": {
        this.selectedHazardoustype = { label: "Compressed Gases", hazardousType: HazardousType.COMPRESSED_GASES }
        break;
      }
      case "Corrosive": {
        this.selectedHazardoustype = { label: "Corrosive", hazardousType: HazardousType.CORROSIVE }
        break;
      }
      case "Flamable Liquids": {
        this.selectedHazardoustype = { label: "Flamable Liquids", hazardousType: HazardousType.FLAMMABLE_LIQUIDS }
        break;
      }
      // case "HAZARDOUS_TO_THE_AQUATIC_ENVIRONMENT": {
      //   this.selectedHazardoustype = { label: HazardousType.HAZARDOUS_TO_THE_AQUATIC_ENVIRONMENT, hazardousType: HazardousType.HAZARDOUS_TO_THE_AQUATIC_ENVIRONMENT }
      //   break;
      // }
      case "Oxidising Liquids": {
        this.selectedHazardoustype = { label: "Oxidising Liquids", hazardousType: HazardousType.OXIDISING_LIQUIDS }
        break;
      }
      case "Toxic Irration": {
        this.selectedHazardoustype = { label: "Toxic Irration", hazardousType: HazardousType.TOXIC_IRRATION }
        break;
      }

    }
  }

  getSelectedBmsProductName(bmsKitProductName, bmsTubeProductName) {
    if (bmsKitProductName == "" || bmsKitProductName == null || bmsKitProductName == undefined)
      this.selectedBmsKitProductName = null;
    else {
      this.bmsProductNames.forEach(element => {
        if (bmsKitProductName != null && element.name == bmsKitProductName) {
          this.selectedBmsKitProductName = element;
        }
      })
    }
    if (bmsTubeProductName == "" || bmsTubeProductName == null || bmsTubeProductName == undefined)
      this.selectedBmsTubeProductName = null;
    else {
      this.bmsProductNames.forEach(element => {
        if (bmsTubeProductName != null && element.name == bmsTubeProductName) {
          this.selectedBmsTubeProductName = element;
        }
      })
    }
  }
  //==> Get Process Step code moved to mdm-process-step.component
  getWellType(wellType: string) {
    switch (wellType) {
      case WellType.WELL96: {
        this.selectedWellType = { label: WellType.WELL96, wellType: WellType.WELL96 }
        break;
      }
      case WellType.WELL384: {
        this.selectedWellType = { label: WellType.WELL384, wellType: WellType.WELL384 }
        break;
      }
    }
  }

  getCategory(category: string) {
    switch (category) {
      case ChemicalCategory.BUFFER: {
        this.selectedCategory = { label: ChemicalCategory.BUFFER, category: ChemicalCategory.BUFFER }
        break;
      }
      case ChemicalCategory.OTHERS: {
        this.selectedCategory = { label: ChemicalCategory.OTHERS, category: ChemicalCategory.OTHERS }
        break;
      }
    }
  }
  //This function is used to save the data into the Db.
  saveMasterList() {

    let masterLists = [...this.masterLists];

    if (this.isNewMasterList) {
      this.saveMasterData(masterLists);
    }
    else {
      this.updateMasterData(masterLists);
    }

    // this.displayMasterListDialog = false;
  }

  //This function deletes the data from the db
  deleteMasterList() {
    let index = this.masterLists.indexOf(this.selectedMasterList);
    this.masterLists = this.masterLists.filter((val, i) => i != index);
    this.masterList = null;
    this.displayMasterListDialog = false;
    this.displayDeleteDialog = false;
  }

  //This function is used to clone the list of masterdata.
  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }
  //if a valid lab name is existing ,the editing for that fiels is disabled
  isLabValid(fieldName) {
    if (this.masterListType == MasterList.LAB) {
      if (this.masterList._id == null || this.masterList._id == isEmpty() || this.masterList._id == undefined) {
        return false;
      } else if (fieldName == "name") {
        return true;
      }
    } else {
      return false;
    }
  }

  checkAndAssignDateFormat(){
    if(this.masterList.dateFormat == undefined ||this.masterList.dateFormat == null){
      this.masterList.dateFormat = 'dd.MM.yyyy'
    }
    if(this.masterList.dateTimeFormat == undefined ||this.masterList.dateTimeFormat == null){
      this.masterList.dateTimeFormat = 'dd.MM.yyyy HH:mm:ss'
    }
    if(this.masterList.workfileNameFormat == undefined ||this.masterList.workfileNameFormat == null){
      this.masterList.workfileNameFormat = 'yyyyMMdd_HHmmss'
    }
  }

  //Updates the list of masterData
  updateMasterData(masterLists) {
    switch (this.masterListType) {
      case MasterList.LAB: {
        this.setLabDetails();
        this.appendHistoryModification("Labs");
        this._masterDataService.updateLab(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            if (results.data.mix2SeqLabId == 0) {
              results.data.mix2SeqLabId = null;
            }
            let localLab = JSON.parse(localStorage.getItem('lab'));
            this.checkAndAssignDateFormat();
            localLab.lab.dateFormat= this.masterList.dateFormat
            localLab.lab.dateTimeFormat= this.masterList.dateTimeFormat
            localLab.lab.workfileNameFormat= this.masterList.workfileNameFormat
            localStorage.setItem('lab',JSON.stringify(localLab));
            console.log("labs:", results.data);
            masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;

      }
      case MasterList.MACHINE: {
        this.masterList.lab = new LabMDM();
        this.masterList.lab = this.selectedLab;
        this.masterList.type = new MachineType();
        this.masterList.type = this.selectedMachineType;
        this.masterList.fileType = this.selectedMachineFileType;
        this.masterList.ioCapacity = this.ioCapacity;
        this.masterList.manufacturer = this.selectedMachineManufacturer;
        this._masterDataService.updateMachine(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("machines:", results.data);
            masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;

      }
      case MasterList.PRINTER: {
        this.masterList.lab = new LabMDM();
        this.masterList.lab = this.selectedLab;
        if (this.selectedTemplate != null) {
          this.masterList.template = this.selectedTemplate;
          this.masterList.template._id = this.selectedTemplate.id;
        }
        else
          this.masterList.template = null;
        this.appendHistoryModification("Printers");
        this._masterDataService.updatePrinter(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("printers:", results.data);
            masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      //==> Process Step code moved to mdm-process-step.component
      case MasterList.QC_TYPE: {
        this.masterList.lab = new LabMDM();
        this.masterList.lab = this.selectedLab;
        this._masterDataService.updateQcType(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("qctype:", results.data);
            masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      case MasterList.BUSINESS_AREA: {
        this._masterDataService.updateBusinessArea(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("business Area:", results.data);
            masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      case MasterList.SEQUENCER_CONFIG:
        {
          this.masterList.lab = new LabMDM();
          this.masterList.lab = this.selectedLab;
          this.masterList.product = new Product();
          this.masterList.product = this.selectedProdType;
          this.masterList.containerType = this.selectedWellType.wellType.toString();
          this._masterDataService.updateSeqConfig(this.masterList).subscribe(
            results => {
              if (!results) {
                return;
              }
              console.log("Seq Config:", results.data);
              masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
              this.masterLists = masterLists;
              this.masterList = null;
              this.displayMasterListDialog = false;
            },
            error => {
              let message = this.errorHandler.handleError(error);
              this._messageService.addErrorMessage(message);
              this.displayMasterListDialog = true;
            }
          );
          break;
        }
      case MasterList.CHEMICAL: {
        this.setChemicalDetails();
        this._masterDataService.updateChemical(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("chemicals:", results.data);
            masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;

      }
      case MasterList.MACHINE_TYPE: {
        this.masterList.lab = new LabMDM();
        this.masterList.lab = this.selectedLab;
        this.appendHistory("Machine Types");
        this._masterDataService.updateMachineType(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("machineTypes:", results.data);
            masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }

      //To save update product
      case MasterList.PRODUCT: {
        this.masterList.lab = new LabMDM();
        this.masterList.lab = this.selectedLab;
        this.masterList.salesItemType = new SalesItemTypeConfig();
        this.masterList.salesItemType = this.selectedSitConfigArray;
        if(this.selectedTagSystem!=undefined){
        this.masterList.tagSystem =  this.selectedTagSystem.tagSystemName;
        }
        this.masterList.workflow = this.selectedWorkflowType.workFlowName;
        if(this.selectedSnpProfile!=null && this.selectedSnpProfile!=undefined){ 
        this.masterList.snpProfile=this.selectedSnpProfile.snpProfileName;
        }else{
          this.masterList.snpProfile=null;
        }
        this.appendHistory("Products");
        this._masterDataService.updateProduct(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("products :", results.data);
            masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      case MasterList.LIB_TYPE: {
        this.masterList.lab = new LabMDM();
        this.masterList.lab = this.selectedLab;
        this.masterList.buffer = new Chemical();
        this.masterList.buffer = this.selectedBufferChemical;
        this.masterList.assayType = this.selectedAssayType != null ? this.selectedAssayType.assayType : null;

        this._masterDataService.updateLibType(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      case MasterList.ECHO_CONFIGURATION:
        {
          this.masterList.lab = new LabMDM();
          this.masterList.lab = this.selectedLab;
          this.masterList.product = new Product();
          this.masterList.product = this.selectedProdType;
          this.masterList.reactionOptionProtocol = this.reactionOption;

          this._masterDataService.updateEchoConfig(this.masterList).subscribe(
            results => {
              if (!results) {
                return;
              }
              console.log("Echo Config [Update] --> :", results.data);
              masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
              this.masterLists = masterLists;
              this.masterList = null;
              this.displayMasterListDialog = false;
            },
            error => {
              let message = this.errorHandler.handleError(error);
              this._messageService.addErrorMessage(message);
              this.displayMasterListDialog = true;
            }
          );
          break;
        }
      case MasterList.SALES_ITEM_TYPE: {
        this.masterList.lab = new LabMDM();
        this.masterList.lab = this.selectedLab;
        this.masterList.bmsKitProductName = this.selectedBmsKitProductName ? this.selectedBmsKitProductName.name : null;
        this.masterList.bmsTubeProductName = this.selectedBmsTubeProductName ? this.selectedBmsTubeProductName.name : null;
        this.masterList.maxRedo = this.selectedMaxRedo;
        this.appendHistory("Sales Item Types");
        this._masterDataService.updateSITConfiguration(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("SIT-Config --> :", results.data);
            masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }

    }
  }

  //Saves the list of masterData
  saveMasterData(masterLists) {
    switch (this.masterListType) {
      case MasterList.LAB: {
        this.setLabDetails();
        this.appendHistoryModification("Labs");
        this._masterDataService.addLab(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            if (results.data.mix2SeqLabId == 0) {
              results.data.mix2SeqLabId = null;
            }
            masterLists = [...this.masterLists];
            console.log("labs:", results.data);
            masterLists.push(results.data);
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      case MasterList.MACHINE: {
        this.masterList.lab = new LabMDM();
        this.masterList.lab = this.selectedLab;
        this.masterList.type = new MachineType();
        this.masterList.type = this.selectedMachineType;
        this.masterList.fileType = this.selectedMachineFileType;
        this.masterList.ioCapacity = this.ioCapacity;
        this.masterList.manufacturer = this.selectedMachineManufacturer;
        this._masterDataService.addMachine(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            masterLists = [...this.masterLists];
            console.log("machines:", results.data);
            masterLists.push(results.data);
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      case MasterList.PRINTER: {
        this.masterList.lab = new LabMDM();
        this.masterList.lab = this.selectedLab;
        if (this.selectedTemplate != null) {
          this.masterList.template = this.selectedTemplate;
          this.masterList.template._id = this.selectedTemplate.id;
        }
        else
          this.masterList.template = null;
        this.appendHistoryModification("Printers");
        this._masterDataService.addPrinter(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            masterLists = [...this.masterLists];
            console.log("printers:", results.data);
            masterLists.push(results.data);
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }

      //adding lab
      case MasterList.PRODUCT: {
        this.masterList.lab = new LabMDM();
        this.masterList.lab = this.selectedLab;
        this.masterList.salesItemType = new SalesItemTypeConfig();
        this.masterList.salesItemType = this.selectedSitConfigArray;
        if(this.selectedTagSystem!=undefined){
        this.masterList.tagSystem =  this.selectedTagSystem.tagSystemName;
        }
        this.masterList.workflow = this.selectedWorkflowType.workFlowName;
        if(this.selectedSnpProfile!=null && this.selectedSnpProfile!=undefined){ 
        this.masterList.snpProfile=this.selectedSnpProfile.snpProfileName;
        }else{
          this.masterList.snpProfile=null;
        }
        this.appendHistory("Products");
        this._masterDataService.addProduct(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            masterLists = [...this.masterLists];
            console.log("products:", results.data);
            masterLists.push(results.data);
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }

      case MasterList.QC_TYPE: {
        this.masterList.lab = new LabMDM();
        this.masterList.lab = this.selectedLab;
        this._masterDataService.addQcType(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            masterLists = [...this.masterLists];
            console.log("qcTypes:", results.data);
            masterLists.push(results.data);
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      //==> Process Step code moved to mdm-process-step.component
      case MasterList.BUSINESS_AREA: {
        this._masterDataService.addBusinessArea(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("business Area:", results.data);
            masterLists.push(results.data);
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      case MasterList.SEQUENCER_CONFIG: {
        this.masterList.lab = new LabMDM();
        this.masterList.lab = this.selectedLab;
        this.masterList.product = new Product();
        this.masterList.product = this.selectedProdType;
        this.masterList.containerType = this.selectedWellType.wellType.toString();
        this._masterDataService.addSeqConfig(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            console.log("Seq Config:", results.data);
            masterLists.push(results.data);
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            console.log(message);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      case MasterList.CHEMICAL: {
        this.setChemicalDetails();
        this._masterDataService.addChemical(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            masterLists = [...this.masterLists];
            console.log("chemicals:", results.data);
            masterLists.push(results.data);
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
            this._messageService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: 'Added Chemical' });
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      case MasterList.MACHINE_TYPE: {
        this.masterList.lab = new LabMDM();
        this.masterList.lab = this.selectedLab;
        this.appendHistory("Machine Types");
        this._masterDataService.addMachineType(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            masterLists = [...this.masterLists];
            console.log("machineTypes:", results.data);
            masterLists.push(results.data);
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      case MasterList.LIB_TYPE: {
        this.masterList.lab = new LabMDM();
        this.masterList.lab = this.selectedLab;
        this.masterList.buffer = new Chemical();
        this.masterList.buffer = this.selectedBufferChemical;
        this.masterList.assayType = this.selectedAssayType != null ? this.selectedAssayType.assayType : null;

        this._masterDataService.addLibType(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            masterLists = [...this.masterLists];

            masterLists.push(results.data);
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }

      case MasterList.ECHO_CONFIGURATION: {
        this.masterList.lab = new LabMDM();
        this.masterList.lab = this.selectedLab;
        this.masterList.product = new Product();
        this.masterList.product = this.selectedProdType;
        this.masterList.reactionOptionProtocol = this.reactionOption;

        this._masterDataService.addEchoConfig(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            masterLists = [...this.masterLists];
            console.log("Echo-Config --> :", results.data);
            masterLists.push(results.data);
            this.masterLists = masterLists;
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }
      case MasterList.SALES_ITEM_TYPE: {
        this.masterList.lab = new LabMDM();
        this.masterList.lab = this.selectedLab;
        this.masterList.bmsKitProductName = this.selectedBmsKitProductName ? this.selectedBmsKitProductName.name : null;
        this.masterList.bmsTubeProductName = this.selectedBmsTubeProductName ? this.selectedBmsTubeProductName.name : null;
        this.masterList.maxRedo = this.selectedMaxRedo;
        this.appendHistory("Sales Item Types");
        this._masterDataService.addSITConfiguration(this.masterList).subscribe(
          results => {
            if (!results) {
              return;
            }
            masterLists = [...this.masterLists];
            console.log("SIT-Config --> :", results.data);
            masterLists.push(results.data);
            this.masterLists = masterLists;
            if (this.masterList.jobTime) {
              this.restartJobService();
            }
            this.masterList = null;
            this.displayMasterListDialog = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
            this.displayMasterListDialog = true;
          }
        );
        break;
      }

    }
  }

  //gets the active options for dropdowns
  getActiveOptionsForDropdowns() {
    this.labOption = [];
    if (MasterList.LAB != this.masterListType && MasterList.BUSINESS_AREA != this.masterListType)
      this._masterDataService.getLabs(true).subscribe(
        results => {
          if (!results) {
            return;
          }
          console.log("Active labs:", results.data);
          this.labOptions = results.data;
          this.labOptions.forEach(lab => {
            if (this.checkSelectedLab &&
              this.checkSelectedLab.lab.name == lab.name) {
              this.labOption.push(lab);
            }

            if (this.masterList && this.masterList.lab && lab._id == this.masterList.lab._id) {
              this.selectedLabName = this.masterList.lab.name;
              this.selectedLab = lab;
            }
          });

          if (this.checkSelectedLab) {
            this.labOptions = this.labOption;
          }
          if (!this.masterList || !this.masterList.lab || this.selectedLabName != this.masterList.lab.name)
            this.selectedLab = null;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );
    if (MasterList.LAB == this.masterListType)
      this._masterDataService.getBusinessAreas(true).subscribe(
        results => {
          if (!results) {
            return;
          }
         if (this.masterList[this.isUnboxingInBatches] == undefined || this.masterList[this.isUnboxingInBatches] == null) {
            this.masterList[this.isUnboxingInBatches] = true;
          }
          if (this.masterList[this.isNumberOfPC] == undefined || this.masterList[this.isUnboxingInBatches] == null) {
            this.masterList[this.isNumberOfPC] = 1;
          }
          if (this.masterList[this.isNumberOfNC] == undefined || this.masterList[this.isUnboxingInBatches] == null) {
            this.masterList[this.isNumberOfNC] = 1;
          }
          if (this.masterList[this.isNumberOfNegativePCRControls] == undefined || this.masterList[this.isNumberOfNegativePCRControls] == null) {
            this.masterList[this.isNumberOfNegativePCRControls] = 1;
          }
          if (this.masterList[this.isNumberOfPositivePCRControls] == undefined || this.masterList[this.isNumberOfPositivePCRControls] == null) {
            this.masterList[this.isNumberOfPositivePCRControls] = 1;
          }
          console.log("Active business Areas:", results.data);
          this.baOptions = results.data;
          this.baOptions.forEach(ba => {
            if (this.masterList && this.masterList.businessArea && ba._id == this.masterList.businessArea._id) {
              this.selectedBaName = this.masterList.businessArea.name;
              this.selectedBA = ba;
            }
          })
          if (!this.masterList || !this.masterList.businessArea || this.selectedBaName != this.masterList.businessArea.name)
            this.selectedBA = null;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );
     
    //to get sales item type
    if (MasterList.PRODUCT == this.masterListType) {
      if(this.isNewMasterList){
        this.masterList.requiredRead=500000;
      } 

      this.tagSystemOptions=[];
   
      this._masterDataService.getTagActiveSystem(this.selectableLab.lab, true).subscribe(
        results => {
          if (!results) {
            return;
          }
          this.tagSystemOptions = results.data;
          if(this.masterList.tagSystem){
            this.tagSystemOptions.forEach(tag=>{
              if(tag.tagSystemName === this.masterList.tagSystem){
                this.selectedTagSystem = tag;
              }
            });
          }
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );

      this.workFlowOptions=[];
   
      this._masterDataService.getActiveWorkFlows(this.selectableLab.lab,true).subscribe(
        results => {
          if (!results) {
            return;
          }
          this.workFlowOptions = results.data;
          if(this.masterList.workflow){
             this.workFlowOptions.forEach(workflow=>{       
               if(workflow.workFlowName === this.masterList.workflow ){
             this.selectedWorkflowType = workflow;
              }
            }); 
          }
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );

      this.snpProfileOptions=[];
      this._masterDataService.getActiveSNPProfiles(this.selectableLab.lab,true).subscribe(
        results => {
          if (!results) {
            return;
          }
          this.snpProfileOptions = results.data;
          if(this.masterList.snpProfile){
            this.snpProfileOptions.forEach(snpProfileData=>{       
              if(snpProfileData.snpProfileName === this.masterList.snpProfile ){
                this.selectedSnpProfile = snpProfileData;
              }
            }); 
          }else{
            this.selectedSnpProfile =null;
          }
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );
      
      this.selectedSitConfigArray = [];
      this.sitConfigOptions = [];
      if(this.masterList.lab!=undefined){
      this.onLabSelect(this.masterList.lab);
      }
    }

    if (MasterList.SEQUENCER_CONFIG == this.masterListType || MasterList.ECHO_CONFIGURATION == this.masterListType)
      this._masterDataService.getProducts(true).subscribe(
        results => {
          if (!results) {
            return;
          }
          console.log("Product", results.data);
          this.productOptions = results.data;
          this.productOptions.forEach(product => {
            if (this.masterList && this.masterList.product && product._id == this.masterList.product._id) {
              this.selectedProdTypeName = this.masterList.product.name;
              this.selectedProdType = product;
            }
          })
          if (!this.masterList || !this.masterList.product || this.selectedProdTypeName != this.masterList.product.name)
            this.selectedProdType = null;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );

    if (MasterList.LIB_TYPE == this.masterListType)
      this._masterDataService.getActiveBufferChemicals(true).subscribe(
        results => {
          if (!results) {
            return;
          }
          console.log("Active chemical Options:", results.data);
          this.bufferChemicalOptions = results.data;
          this.bufferChemicalOptions.forEach(buffer => {
            if (this.masterList && this.masterList.buffer && buffer._id == this.masterList.buffer._id) {
              this.selectedBufferName = this.masterList.buffer.name;
              this.selectedBufferChemical = buffer;
            }
          })
          if (!this.masterList || !this.masterList.buffer || this.selectedBufferName != this.masterList.buffer.name)
            this.selectedBufferChemical = null;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );

    if (MasterList.PRINTER == this.masterListType) {
      this.labelTemplateOptions = [];
      if (this.masterList.lab != null) {
        this.selectedLab = this.masterList.lab;
        this.onLabSelect(this.selectedLab);
      }
    }

    if (MasterList.MACHINE == this.masterListType) {
      if (this.masterList.lab != null) {
        this.selectedLab = this.masterList.lab;
        this.onLabSelect(this.selectedLab);
      }
    }
  }

  setLabDetails() {
    this.masterList.businessArea = new BusinessArea();
    this.masterList.businessArea = this.selectedBA;
    this.masterList.defaultLanguage = navigator.languages ? navigator.languages[0] : (navigator.language);
    this.masterList.countryCode = this.selectedCountryCode;
    this.masterList.dateFormat=this.selectedDateFormat;
    this.masterList.dateTimeFormat=  this.selectedDateTimeFormat;
    this.masterList.workfileNameFormat = this.selectedWorkfileFormat;
    if (this.masterList.mix2SeqLabId == 0) {
      this.masterList.mix2SeqLabId = null;
    }

  }
  setChemicalDetails() {
    this.masterList.lab = this.selectedLab;
    this.masterList.type = MaterialType.Chemical;
    this.masterList.category = this.selectedCategory.label.toString();
    if (this.selectedHazardoustype != null)
      this.masterList.hazardousType = this.selectedHazardoustype.label;
  }

  //Returns true if the save button has to be disabled for the editing popup
  isSaveDisabled() {
    if (this.masterList == undefined || this.masterList == null)
      return true;
    switch (this.masterListType) {
      case MasterList.LAB: {
        if (!this.selectedCountryCode || !this.selectedBA || !this.masterList.name || !this.masterList.city)
          return true;
        return false;
      }
      case MasterList.MACHINE: {
        if (!this.masterList.name || !this.selectedLab || !this.selectedMachineType || !this.masterList.barcode || !this.isNotIpAddress)
          return true;
        return false;
      }
      case MasterList.PRINTER: {
        if (!this.masterList.ipAddress || !this.selectedLab )
          return true;
        return false;
      }
      case MasterList.QC_TYPE: {
        if (!this.selectedLab || !this.masterList.type)
          return true;
        return false;
      }
      case MasterList.BUSINESS_AREA: {
        return !this.masterList.name
      }
      case MasterList.SEQUENCER_CONFIG: {
        if ((!this.selectedLab) ||
          (!this.selectedProdType) ||
          (!this.masterList.description) ||
          (!this.masterList.application) ||
          (!this.selectedWellType) ||
          (!this.masterList.owner) ||
          (!this.masterList.operator) ||
          (!this.masterList.plateSealing) ||
          (!this.masterList.resultsGroup) ||
          (!this.masterList.instrumentProtocol1) ||
          (!this.masterList.analysisProtocol1))
          return true;
        return false;
      }
      case MasterList.CHEMICAL: {
        if (!this.masterList.name)
          return true;
        return false;
      }
      case MasterList.MACHINE_TYPE: {
        return (!this.masterList.name || !this.selectedLab)
      }

      //to make save of Product enabled
      case MasterList.PRODUCT: {
        if (!this.masterList.name || !this.selectedLab || !this.selectedSitConfigArray || this.masterList.active && !this.selectedTagSystem || !this.selectedWorkflowType)
          return true;
        return false;
      }

      case MasterList.LIB_TYPE: {
        if (!this.masterList.name || !this.selectedLab)
          return true;
        return false;
      }
      case MasterList.ECHO_CONFIGURATION: {
        if ((!this.selectedLab) ||
          (!this.selectedProdType) ||
          (!this.masterList.masterMixBarcode) ||
          (!this.masterList.masterMixPlateType) ||
          (!this.masterList.masterMixVolume) && (this.masterList.masterMixVolume != 0) ||
          (!this.masterList.sourcePlateType) ||
          (!this.masterList.sampleVolume) && (this.masterList.sampleVolume != 0) ||
          (!this.masterList.standardPrimerVolume) && (this.masterList.standardPrimerVolume != 0) ||
          (!this.masterList.synthesizedPrimerVolume) && (this.masterList.synthesizedPrimerVolume != 0) ||
          (!this.masterList.enclosedPrimerVolume) && (this.masterList.enclosedPrimerVolume != 0))
          return true;
        return false;
      }
      case MasterList.SALES_ITEM_TYPE: {
        if (!this.selectedLab)
          return true;
        return false;
      }
      default: return true;
    }
  }

  //Handling the change in job timing
  changeJobTimeForProduct() {
    if (confirm("You have modified job time for the product! do you want to proceed?")) {
      this.saveMasterList();
      this.restartJobService();
    } else {
      this.displayMasterListDialog = false;
    }
  }

  //The Job restart caller function
  restartJobService() {
    this._masterDataService.restartJobSchedularService().subscribe(
      results => {
        if (!results) {
          return;
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  //To run job for a product on demand
  runJobForProduct() {
    this._masterDataService.triggerJob(this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.displayMasterListDialog = false;
        this._messageService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: 'Tiggered Order Creation Job' });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  ipNameEnforce(hostAddressValue) {
    let givenIpValue = hostAddressValue.target.value;
    // tslint:disable-next-line:max-line-length
    if (givenIpValue.match('^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(:)?(:[0-9]+)?$')) {
      this.isNotIpAddress = false;
      this.warningText = 'Please enter Domain Name in place of IP address.';
    } else {
      this.isNotIpAddress = true;
    }
  }

  setSubType() {
    if (this.masterList.subType.trim() == '')
      this.masterList.subType = null;
  }

  appendHistory(tabName: string){
    let historyObj:OperetionHistoryDTO = new OperetionHistoryDTO();
    historyObj.puid = this.puid;
    historyObj.operationDateTime = new Date();
    historyObj.tabName = tabName;
    if(this.masterList.history){
      this.masterList.history.push(historyObj);
    } else {
      this.masterList.history = [];
      this.masterList.history.push(historyObj);
    }
  }

  appendHistoryModification(tabName: string){
    let historyObj:OperetionHistoryDTO = new OperetionHistoryDTO();
    historyObj.puid = this.puid;
    historyObj.operationDateTime = new Date();
    historyObj.tabName = tabName;
    if(this.masterList.modificationHistory){
      this.masterList.modificationHistory.push(historyObj);
    } else {
      this.masterList.modificationHistory = [];
      this.masterList.modificationHistory.push(historyObj);
    }
  }
}
